module.exports = __webpack_public_path__ + "static/terrapex-logo-22770f9b16ed048513a11a5b9edf3af5.png";